query GetSMSDashboard($input: DashboardInput!) {
    inboxDashboard(input: $input) {
        stats {
            delta {
                timespanSuffix
                direction
                percentChange
            }
            name
            formattedValue
        }
    }
}
